import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ArrowLeft, Mail, Phone, User as UserIcon, KeyRound } from "lucide-react";
import NotesPanel from "../components/NotesPanel";

const roleBadge = (r) => {
  switch (r) {
    case "admin":   return "se-badge se-badge-active";
    case "manager": return "se-badge se-badge-active";
    case "vet":     return "se-badge se-badge-warning";
    default:        return "se-badge se-badge-inactive";
  }
};

export default function UserProfile() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { user: me } = useAuth();
  const [u, setU] = useState(null);
  const [error, setError] = useState("");
  const isSelf = u && me && u.id === me.id;

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/users/${userId}`);
        setU(data);
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, [userId]);

  return (
    <div data-testid="user-profile-page">
      <button onClick={() => navigate("/staff")} className="se-btn se-btn-ghost mb-6" data-testid="user-profile-back">
        <ArrowLeft size={16} /> Back to staff
      </button>

      {error && <div className="se-card mb-4" style={{ color: "#922B21" }} data-testid="user-profile-error">{error}</div>}

      {u && (
        <>
          <div className="se-card mb-6">
            <div className="flex items-start gap-5">
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0"
                style={{ background: "#7C5C3A", color: "#F5EFE6" }}
              >
                <UserIcon size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="se-label">Staff profile</div>
                <h1 className="font-heading mt-1" style={{ fontSize: 28 }} data-testid="user-profile-name">
                  {u.full_name}
                </h1>
                <div className="flex flex-wrap gap-x-6 gap-y-2 mt-3 text-sm" style={{ color: "#8C9E8A" }}>
                  {u.email && <span className="inline-flex items-center gap-2"><Mail size={14} /> {u.email}</span>}
                  {u.phone && <span className="inline-flex items-center gap-2"><Phone size={14} /> {u.phone}</span>}
                </div>
              </div>
              <span className={roleBadge(u.role)}>{u.role}</span>
            </div>
            {isSelf && (
              <div className="mt-5 pt-4 flex justify-end" style={{ borderTop: "0.5px solid rgba(212,169,106,0.25)" }}>
                <button
                  className="se-btn se-btn-ghost"
                  onClick={() => navigate("/change-password")}
                  data-testid="user-change-password-button"
                >
                  <KeyRound size={14} /> Change my password
                </button>
              </div>
            )}
          </div>

          <NotesPanel targetType="user" targetId={u.id} testid="user-notes" />
        </>
      )}
    </div>
  );
}
